import React, { FC } from 'react'
import { createPortal } from 'react-dom'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../redux/store'
import styles from './DeleteModal.module.css'
import classNames from 'classnames'
import { useClearBodyNoScrollClass } from '../../hooks/use-clear-body-no-scroll-slass'

type DeleteModalProps = {
  title?: string
  heading?: string
  onConfirm: any
  onCancel: any
  skipDispatch?: boolean
  variant?: 'danger' | 'confirm'
}

const DeleteModal: FC<DeleteModalProps> = ({
  title = '',
  heading,
  onConfirm,
  onCancel,
  skipDispatch = false,
  variant = 'danger',
}) => {
  const dispatch = useDispatch<AppDispatch>()
  useClearBodyNoScrollClass()

  const runConfirm = () => {
    if (skipDispatch) {
      ;(onConfirm as () => void)()
    } else {
      dispatch(onConfirm as Parameters<AppDispatch>[0])
    }
  }

  const runCancel = () => {
    if (skipDispatch) {
      ;(onCancel as () => void)()
    } else {
      dispatch(onCancel as Parameters<AppDispatch>[0])
    }
  }

  const node = (
    <div style={{ display: 'block' }} className={styles.win}>
      <div className={styles.winContainer}>
        <div className={styles.winContent}>
          <div className={styles.close} onClick={runCancel}>
            ×
          </div>
          <div className={styles.winContentFulltext}>
            <h4
              style={{ textAlign: 'center' }}
              className={classNames(
                variant === 'confirm'
                  ? styles.colorBlueHeading
                  : styles.colorRed,
                styles.h4,
                'mb-5'
              )}
            >
              {heading ?? `Вы уверены, что хотите удалить ${title}?`}
            </h4>

            <div className="row mt-2">
              <div
                className="col-12 col-sm-8 mt-1 mb-1"
                style={{ textAlign: 'right' }}
              >
                <button
                  type="button"
                  onClick={runConfirm}
                  className={classNames(
                    styles.btn,
                    variant === 'confirm' && styles.btnBlue,
                    'd-block d-sm-inline-block'
                  )}
                >
                  ДА, Я УВЕРЕН
                </button>
              </div>
              <div
                className="col-12 col-sm-4 mt-1 mb-1"
                style={{ textAlign: 'right' }}
              >
                <div
                  role="button"
                  tabIndex={0}
                  onClick={runCancel}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault()
                      runCancel()
                    }
                  }}
                  className={`${styles.btn} ${styles.btnSmall} ${styles.btnBlueOutline} d-block d-sm-inline-block`}
                >
                  Отмена
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  if (typeof document === 'undefined') {
    return node
  }

  return createPortal(node, document.body)
}

export default DeleteModal
